import { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Day } from 'lumen/models';
import ShortTermRentalOccupancy from 'lumen/models/short-term-rental-occupancy';

export default class CompareShortTermRentalOccupancy extends ShortTermRentalOccupancy {
  // @ts-expect-error: Class inheritance
  [Type] = 'compare-short-term-rental-occupancy' as const;

  @belongsTo('day', {
    async: true,
    inverse: 'compareShortTermRentalOccupancies',
  })
  declare day: Day;

  modelName = 'compare-short-term-rental-occupancy';
}
